/*
 * product-image-promote.js
 *
 * Product page, stacked gallery (desktop). All gated by the section's
 * `image_zoom: none` setting (which disables Dawn's zoom lightbox):
 *
 *   1. Click a gallery image (or use the prev / next arrows overlaid on the
 *      main image) -> it becomes the main image. Dawn renders the first
 *      `.product__media-item` full-width and the rest in a 2-up grid, so
 *      "promote" == move that <li> to the front of `.product__media-list`.
 *      The arrows step through the gallery's original order, wrapping around.
 *
 *   2. If the promoted image is attached to a variant, that variant is
 *      pre-selected: the matching option inputs in `<variant-selects>` are
 *      checked and a `change` event is fired, so Dawn's `product-info.js` runs
 *      its normal variant-change flow (price / URL / buy button / media).
 *      Map data comes from the `<script data-variant-media-map>` blob rendered
 *      by `sections/main-product.liquid`.
 *
 * Loaded by `sections/main-product.liquid` only when `image_zoom == 'none'` and
 * the product has more than one media item.
 */
(function () {
  var DESKTOP = '(min-width: 990px)';
  var mql = window.matchMedia(DESKTOP);

  function isDesktop() {
    return mql.matches;
  }

  function init() {
    var list = document.querySelector('media-gallery .product__media-list');
    if (!list || list.closest('product-media-modal')) return;

    function items() {
      return Array.prototype.filter.call(list.children, function (el) {
        return el.classList && el.classList.contains('product__media-item');
      });
    }

    var initial = items();
    if (initial.length < 2) return;

    // Stamp the original order so it survives Dawn re-ordering the <ul> on a
    // variant change (Dawn moves the same <li> nodes, it doesn't rebuild them).
    initial.forEach(function (el, i) {
      el._galleryIndex = i;
    });

    function firstItem() {
      return items()[0];
    }

    function orderedItems() {
      return items().sort(function (a, b) {
        var ai = a._galleryIndex == null ? Number.MAX_SAFE_INTEGER : a._galleryIndex;
        var bi = b._galleryIndex == null ? Number.MAX_SAFE_INTEGER : b._galleryIndex;
        return ai - bi;
      });
    }

    function mediaIdOf(item) {
      var m = String(item.getAttribute('data-media-id') || '').match(/(\d+)\s*$/);
      return m ? m[1] : null;
    }

    // --- variant map -----------------------------------------------------------
    var byMedia = null;
    var mapEl = document.querySelector('script[type="application/json"][data-variant-media-map]');
    if (mapEl) {
      try {
        var entries = JSON.parse(mapEl.textContent);
        if (Array.isArray(entries) && entries.length) {
          byMedia = {};
          entries.forEach(function (e) {
            if (e && e.media != null) byMedia[String(e.media)] = e;
          });
        }
      } catch (e) {
        /* leave byMedia null */
      }
    }

    function variantSelects() {
      return document.querySelector('product-info variant-selects') || document.querySelector('variant-selects');
    }

    function currentVariantId() {
      var vs = variantSelects();
      var el = vs && vs.querySelector('[data-selected-variant]');
      if (!el) return null;
      try {
        return String((JSON.parse(el.textContent) || {}).id);
      } catch (e) {
        return null;
      }
    }

    // Check the option inputs for this variant's option values, then fire one
    // change event so <variant-selects> picks up the whole combination.
    function selectVariant(entry) {
      var vs = variantSelects();
      if (!vs) return;
      var groups = vs.querySelectorAll('.product-form__input');
      var options = (entry.options || []).filter(function (v) {
        return v != null && v !== '';
      });
      var changed = null;

      options.forEach(function (optValue, i) {
        var group = groups[i];
        if (!group) return;
        var controls = group.querySelectorAll('input[type="radio"], select option');
        var match = null;
        for (var c = 0; c < controls.length; c++) {
          if (controls[c].value === String(optValue)) {
            match = controls[c];
            break;
          }
        }
        if (!match) return;

        if (match.tagName === 'OPTION') {
          var select = match.closest('select');
          if (select && select.value !== match.value) {
            select.value = match.value;
            changed = select;
          }
        } else if (!match.checked) {
          match.checked = true;
          changed = match;
        }
      });

      if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function syncVariant(item) {
      if (!byMedia) return;
      var id = mediaIdOf(item);
      if (!id) return;
      var entry = byMedia[id];
      if (!entry || String(entry.variant) === currentVariantId()) return;
      selectVariant(entry);
    }

    // --- arrows --------------------------------------------------------------
    var chevron =
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var nav = document.createElement('div');
    nav.className = 'product-media-nav';
    nav.innerHTML =
      '<button type="button" class="product-media-nav__btn product-media-nav__btn--prev" aria-label="Previous image">' +
      chevron +
      '</button>' +
      '<button type="button" class="product-media-nav__btn product-media-nav__btn--next" aria-label="Next image">' +
      chevron +
      '</button>';

    nav.querySelector('.product-media-nav__btn--prev').addEventListener('click', function (e) {
      e.preventDefault();
      step(-1);
    });
    nav.querySelector('.product-media-nav__btn--next').addEventListener('click', function (e) {
      e.preventDefault();
      step(1);
    });

    function placeNav() {
      var first = firstItem();
      if (!first) return;
      var host = first.querySelector('.product-media-container') || first;
      if (nav.parentElement !== host) host.appendChild(nav);
    }

    // --- promote / step ---------------------------------------------------------
    function promote(item, keepScroll) {
      if (!item || !item.parentElement) return;
      if (list.firstElementChild !== item) {
        list.insertBefore(item, list.firstElementChild);
      }
      items().forEach(function (el) {
        el.classList.toggle('is-active', el === item);
      });
      placeNav();

      if (!keepScroll) {
        var rect = item.getBoundingClientRect();
        if (rect.top < -0.5) {
          window.scrollTo({ top: rect.top + window.scrollY, behavior: 'smooth' });
        }
      }

      syncVariant(item);
    }

    function step(dir) {
      var ordered = orderedItems();
      var i = ordered.indexOf(firstItem());
      if (i === -1) i = 0;
      promote(ordered[(i + dir + ordered.length) % ordered.length], true);
    }

    // --- click to promote -------------------------------------------------------
    list.addEventListener('click', function (event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (event.target.closest('.product-media-nav')) return;

      var item = event.target.closest('.product__media-item');
      if (!item) return;

      // Still images only — leave video / 3D-model play buttons alone.
      var container = item.querySelector('.product-media-container');
      if (container && !container.classList.contains('media-type-image')) return;

      if (isDesktop()) {
        // Desktop: promote to main image (this also syncs the variant).
        if (item === firstItem()) return;
        promote(item);
      } else {
        // Mobile: the stacked gallery isn't reordered, but tapping a
        // variant-linked image still pre-selects that variant.
        syncVariant(item);
      }
    });

    // Dawn re-orders the <ul> on a variant change — keep the arrows on the
    // image that ends up first.
    var navRaf = 0;
    new MutationObserver(function () {
      if (navRaf) return;
      navRaf = requestAnimationFrame(function () {
        navRaf = 0;
        if (isDesktop()) placeNav();
      });
    }).observe(list, { childList: true });

    // --- desktop / mobile sync ------------------------------------------------
    function sync() {
      if (isDesktop()) {
        placeNav();
      } else if (nav.parentElement) {
        nav.parentElement.removeChild(nav);
      }
    }
    sync();
    if (mql.addEventListener) {
      mql.addEventListener('change', sync);
    } else if (mql.addListener) {
      mql.addListener(sync);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
